import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import CustomImage from './CustomImage/CustomImage';

interface Props {
    image?: string;
    alt: string;
    children: ReactNode | ReactNode[];
    imageHeight?: number;
    containerClassName?: string;
    contentClassName?: string;
    borderClassName?: string;
    icon?: string;
    inspectorProps?: any;
}

const RoundedImageCard: FC<Props> = ({
    image,
    alt,
    children,
    imageHeight = 221,
    containerClassName,
    contentClassName,
    borderClassName = 'tw-border-br-190',
    icon,
    inspectorProps = {},
}) => {
    return (
        <div
            className={classNames(
                'tw-relative tw-w-full tw-overflow-hidden tw-rounded-lg tw-border-[0.5px] tw-border-gray-light tw-bg-white tw-shadow-lg',
                containerClassName,
            )}>
            {image && (
                <div className="tw-w-full tw-relative" style={{ height: `${imageHeight}px` }}>
                    <div
                        className={classNames('tw-overflow-hidden', borderClassName)}
                        style={{ height: `${imageHeight}px` }}>
                        <CustomImage
                            src={image}
                            alt={alt}
                            height={imageHeight}
                            width={380}
                            className="tw-h-full tw-w-full tw-object-cover"
                            {...inspectorProps}
                        />
                    </div>

                    {icon && (
                        <div className="tw-absolute tw-bottom-0 tw-right-0 tw-mr-4">
                            <CustomImage src={icon} alt="icon" height={40} width={40} />
                        </div>
                    )}
                </div>
            )}
            <div className={classNames('tw-p-4', contentClassName)}>{children}</div>
        </div>
    );
};

export default RoundedImageCard;
